import { Button } from "antd";
import styled from "styled-components";

export const StyledButton = styled(Button)`
    display: flex;
    padding: 8px 16px;
    width: 150px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 32px;
    background: ${({ theme }) => theme?.colors?.theme?.contentBg};
    border: none;
    color: ${({ theme }) => theme?.colors?.text?.headings};
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    .ant-space {
        width: 100%;
        justify-content: space-between;
        
        span {
            text-overflow: ellipsis;
            overflow: hidden;
            font-size: clamp(12px, 3.5vw, 14px);
        }
    }

    &:hover, &:focus {
        background: ${({ theme }) => theme?.colors?.theme?.contentBg} !important;
        color: ${({ theme }) => theme?.colors?.text?.headings} !important;
    }
`;

export const MenuContainer = styled.div`
    background: ${({ theme }) => theme?.colors?.theme?.contentBg};
    border-radius: 16px;
    box-shadow: 0px 4px 4px 0px rgba(10, 20, 26, 0.50);
    backdrop-filter: blur(8px);

    .ant-dropdown-menu {
        background: transparent;
        border: none;
        box-shadow: none;
        
        .ant-dropdown-menu-item {
            border-radius: 32px;
            color: ${({ theme }) => theme?.colors?.text?.headings};

            &:hover {
                background: ${({ theme }) => theme?.colors?.text?.muted};
            }

                &-selected {
                background: ${({ theme }) => theme?.colors?.text?.muted};
            }
        }
    }
`;